import React, { useCallback, useEffect, useState }  from 'react';
import styled from 'styled-components';
import TableComponent from '../components/tables/TableComponent';
import { User } from '../types/global';
import UserDataService from '../services/UserService';
import { Spinner } from 'react-bootstrap';

const UserTableContainer = styled.div`
    width: 90vw;
    overflow: overlay;
    position: absolute;
    top: 10em;
    height: 70%;
`
const UserButtonContainer = styled.div`
    position: absolute;
    top: 6em;
    right: 6%;
`

const Dashboard = () => {

    const [usersObject, setUsersObject] = useState<User[]>([]);
    const [userToDelete, setUserToDelete] = useState<string | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [isSpinnerVisible, setIsSpinnerVisible] = useState(true);
    const [isShowUpdateModal, setIsShowUpdateModal] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await UserDataService.getAllUsers();
                    setUsersObject(res.data);
                    setIsSpinnerVisible(false);
            } catch (error) {
                console.log('error', error);
                setIsSpinnerVisible(false);
            }
        }
        fetchUsers();
    }, [])

    const deleteUserHandler = useCallback(async (_id: string) => {
        console.log('id', _id);
        setUserToDelete(_id);
        setShowDeleteModal(true);
    }, []);

    const confirmDeleteHandler = useCallback(async () => {
        if (userToDelete) {
            try {
            await UserDataService.deleteUser(userToDelete);
            setUsersObject(prevUsers => {
                const updatedUsers = prevUsers.filter(user => user._id !== userToDelete);
                console.log('After update:', updatedUsers);
                return updatedUsers;
            });
            setShowDeleteModal(false);
            } catch (error) {
                console.error('Failed to delete user:', error);
            }
            setUserToDelete(null);
        }
    }, [userToDelete])

    const handleUserAdded = async (newUser: User) => {
        setUsersObject(prevUsers => {
            const updatedUsers = [...prevUsers, newUser];
            return updatedUsers;
        });
    };

    return(
        <>
            {isSpinnerVisible ? (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <Spinner animation="border" />
                </div>
            ) : (
                <TableComponent
                    key={usersObject.length}
                    users={usersObject}
                    deleteUserHandler={deleteUserHandler}
                    confirmDeleteHandler={confirmDeleteHandler}
                    showDeleteModal={showDeleteModal}
                    setShowDeleteModal={setShowDeleteModal}
                    onUserAdded={handleUserAdded}
                    setIsShowUpdateModal={setIsShowUpdateModal}
                    isShowUpdateModal={isShowUpdateModal}
                    setUsersObject={setUsersObject}
                />
            )}
        </>
    )
}

export default Dashboard